export default __webpack_public_path__ + "static/media/fa.bundle.52f619d9.svg";